import { reactModule } from './utils/react';

const modules = [
    {
        name: 'accordion',
        loader: () => import('./modules/accordion')
    },
    {
        name: 'application-selector',
        loader: () => import('./react-modules/application-selector'),
        render: reactModule
    },
    {
        name: 'advanced-search-block',
        loader: () => import('./react-modules/advanced-search-block'),
        render: reactModule
    },
    {
        name: 'advanced-sales-news-results-block',
        loader: () => import('./react-modules/advanced-sales-news-results-block'),
        render: reactModule
    },
    {
        name: 'age-reqs',
        loader: () => import('./react-modules/age-reqs'),
        render: reactModule
    },
    {
        name: 'breadcrumb',
        loader: () => import('./react-modules/breadcrumb'),
        render: reactModule
    },
    {
        name: 'connections',
        loader: () => import('./react-modules/connections'),
        render: reactModule
    },
    {
        name: 'carrier-guidelines-accordion-listing',
        loader: () =>
            import('./react-modules/carrier-guidelines-accordion-listing'),
        render: reactModule
    },
    {
        name: 'carrier-plan-tabs',
        loader: () => import('./react-modules/carriers-plan'),
        render: reactModule
    },
    {
        name: 'carrier-detail-tabs',
        loader: () => import('./react-modules/carrier-detail-tabs'),
        render: reactModule
    },
    {
        name: 'carrier-switcher',
        loader: () => import('./react-modules/carrier-switcher'),
        render: reactModule
    },
    {
        name: 'carrier-news-listing',
        loader: () => import('./react-modules/carrier-news-listing'),
        render: reactModule
    },
    {
        name: 'carriers-listing',
        loader: () => import('./react-modules/carriers-listing'),
        render: reactModule
    },
    {
        name: 'consumer-site-settings',
        loader: () => import('./react-modules/consumer-site-settings'),
        render: reactModule
    },
    {
        name: 'consumer-site-landing__service-agreement-modal',
        loader: () =>
            import('./react-modules/consumer-site-landing__service-agreement-modal'),
        render: reactModule
    },
    {
        name: 'contracting-table',
        loader: () => import('./react-modules/contracting-table'),
        render: reactModule
    },
    {
        name: 'coverage-calculator',
        loader: () => import('./react-modules/coverage-calculator'),
        render: reactModule
    },
    {
        name: 'cobrands-login',
        loader: () => import('./react-modules/cobrands-login'),
        render: reactModule
    },
    {
        name: 'commission-statements',
        loader: () => import('./react-modules/commission-statements'),
        render: reactModule
    },
    {
        name: 'commissions-projections',
        loader: () => import('./react-modules/commissions-projections'),
        render: reactModule
    },
    {
        name: 'commissions-calculator',
        loader: () => import('./react-modules/commissions-calculator'),
        render: reactModule
    },
    {
        name: 'commissions-activity',
        loader: () => import('./react-modules/commissions-activity'),
        render: reactModule
    },
    {
        name: 'contact-information-details',
        loader: () => import('./react-modules/contact-information-details'),
        render: reactModule
    },
    {
        name: 'contact-us-block',
        loader: () => import('./react-modules/contact-us-block'),
        render: reactModule
    },
    {
        name: 'commission-inquiry',
        loader: () => import('./react-modules/commission-inquiry'),
        render: reactModule
    },
    {
        name: 'disclaimer-modal',
        loader: () => import('./modules/disclaimer-modal')
    },
    {
        name: 'dynamic-help-card',
        loader: () => import('./modules/dynamic-help-card')
    },
    {
        name: 'drop-ticket',
        loader: () => import('./react-modules/drop-ticket'),
        render: reactModule
    },
    {
        name: 'ensight-validation',
        loader: () => import('./react-modules/ensight-validation'),
        render: reactModule
    },
    {
        name: 'ensight-attestation',
        loader: () => import('./react-modules/ensight-attestation'),
        render: reactModule
    },
    {
        name: 'electronic-commissions',
        loader: () => import('./react-modules/electronic-commissions'),
        render: reactModule
    },
    {
        name: 'econtracting-modal',
        loader: () => import('./modules/econtracting-modal')
    },
    {
        name: 'error-search',
        loader: () => import('./modules/error-search')
    },
    {
        name: 'event-listing',
        loader: () => import('./react-modules/event-listing'),
        render: reactModule
    },
    {
        name: 'faq',
        loader: () => import('./react-modules/faq'),
        render: reactModule
    },
    {
        name: 'header',
        loader: () => import('./react-modules/header'),
        render: reactModule
    },
    {
        name: 'home-page-dashboard',
        loader: () => import('./react-modules/home-page-dashboard'),
        render: reactModule
    },
    {
        name: 'ltc-case-analysis',
        loader: () => import('./react-modules/ltc-case-analysis'),
        render: reactModule
    },
    {
        name: 'leads',
        loader: () => import('./react-modules/leads'),
        render: reactModule
    },
    {
        name: 'masthead',
        loader: () => import('./modules/masthead')
    },
    {
        name: 'my-cases',
        loader: () => import('./react-modules/my-cases'),
        render: reactModule
    },
    {
        name: 'my-uploads',
        loader: () => import('./react-modules/my-uploads'),
        render: reactModule
    },
    {
        name: 'underwriting-news-and-events-results-block',
        loader: () =>
            import('./react-modules/underwriting-news-and-events-results-block'),
        render: reactModule
    },
    {
        name: 'news-listing',
        loader: () => import('./react-modules/news-listing'),
        render: reactModule
    },
    {
        name: 'pre-appointments',
        loader: () => import('./react-modules/pre-appointments'),
        render: reactModule
    },
    {
        name: 'product-line-news-carousel',
        loader: () => import('./modules/product-line-news-carousel')
    },
    {
        name: 'quote-and-transact',
        loader: () => import('./react-modules/quote-and-transact'),
        render: reactModule
    },
    {
        name: 'quick-search-listing',
        loader: () => import('./react-modules/quick-search-listing'),
        render: reactModule
    },
    {
        name: 'sales-assist',
        loader: () => import('./react-modules/sales-assist'),
        render: reactModule
    },
    {
        name: 'search-page-filters-and-results-block',
        loader: () =>
            import('./react-modules/search-page-filters-and-results-block'),
        render: reactModule
    },
    {
        name: 'support-team',
        loader: () => import('./react-modules/support-team'),
        render: reactModule
    },
    {
        name: 'software-downloads',
        loader: () => import('./react-modules/software-downloads'),
        render: reactModule
    },
    {
        name: 'state-listing',
        loader: () => import('./react-modules/state-listing'),
        render: reactModule
    },
    {
        name: 'saved-quotes',
        loader: () => import('./react-modules/saved-quotes'),
        render: reactModule
    },
    {
        name: 'sales-team',
        loader: () => import('./react-modules/sales-team'),
        render: reactModule
    },
    {
        name: 'tc-quick-quote',
        loader: () => import('./react-modules/tc-quick-quote'),
        render: reactModule
    },
    {
        name: 'tabs',
        loader: () => import('./modules/tabs')
    },
    {
        name: 'tab-carousel',
        loader: () => import('./modules/tab-carousel')
    },
    {
        name: 'tab-table-rate',
        loader: () => import('./react-modules/tab-table-rate'),
        render: reactModule
    },
    {
        name: 'technology-support',
        loader: () => import('./react-modules/technology-support'),
        render: reactModule
    },
    {
        name: 'timed-redirect',
        loader: () => import('./modules/timed-redirect')
    },
    {
        name: 'timeout-warning',
        loader: () => import('./modules/timeout-warning-modal')
    },
    {
        name: 'underwriting-questionnaire-set-search',
        loader: () =>
            import('./react-modules/underwriting-questionnaire-set-search'),
        render: reactModule
    },
    {
        name: 'upload-type',
        loader: () => import('./react-modules/upload-type'),
        render: reactModule
    },
    {
        name: 'users-listing',
        loader: () => import('./react-modules/users-listing'),
        render: reactModule
    },
    {
        name: 'webinar-listing',
        loader: () => import('./react-modules/webinar-listing'),
        render: reactModule
    },
    {
        name: 'lead-details',
        loader: () => import('./react-modules/lead-details'),
        render: reactModule
    },
    {
        name: 'case-details',
        loader: () => import('./react-modules/case-details'),
        render: reactModule
    },
    {
        name: 'communications-settings',
        loader: () => import('./react-modules/communications-settings'),
        render: reactModule
    },
    {
        name: 'commissions-search',
        loader: () => import('./react-modules/commissions-search'),
        render: reactModule
    },
    {
        name: 'transaction-summary',
        loader: () => import('./react-modules/transaction-summary'),
        render: reactModule
    },
    {
        name: 'transaction-details',
        loader: () => import('./react-modules/transaction-details'),
        render: reactModule
    },
    {
        name: 'illustration-request',
        loader: () => import('./react-modules/illustration-request'),
        render: reactModule
    },
    {
        name: 'consumer-site-dashboard',
        loader: () => import('./react-modules/consumer-site-dashboard'),
        render: reactModule
    },
    {
        name: 'marketing-tools',
        loader: () => import('./react-modules/marketing-tools'),
        render: reactModule
    },
    {
        name: 'consumer-site-notification',
        loader: () => import('./react-modules/consumer-site-notification'),
        render: reactModule
    },
    {
        name: 'site-setting-control',
        loader: () => import('./react-modules/site-setting-control'),
        render: reactModule
    },
    {
        name: 'site-alert-banner',
        loader: () => import('./react-modules/site-alert-banner'),
        render: reactModule
    },
    {
        name: 'sso-login-agent-selector',
        loader: () => import('./modules/sso-login-agent-selector')
    },
    {
        name: 'questionnaire-landing',
        loader: () => import('./react-modules/underwriting-digitized-questionnaire/pages/questionnaires'),
        render: reactModule
    },
    {
        name: 'questionnaire-detail',
        loader: () => import('./react-modules/underwriting-digitized-questionnaire/pages/questionnaire-detail'),
        render: reactModule
    },
    {
        name: 'renewal-list',
        loader: () => import('./react-modules/renewal-list'),
        render: reactModule
    }
];

export default [...modules];
